// external
import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classNames from "classnames";

// state managing
import { FaoBuilderContext } from "context/FaoBuilderContext";

// components
import { STEPS } from "../pages/fao-builder/constants/faob-steps.constants";
import CustomButton from "./partials/custom-button/custom-button";

const ProgressTracker = () => {
  const { modelConfig } = useContext(FaoBuilderContext);
  const location = useLocation();
  const currentStep = location.pathname.split("/").pop();
  const currentStepNumber = STEPS.find(
    (item) => item.route === currentStep
  )?.number;
  const navigate = useNavigate();

  const isStepComplete = (step) => {
    if (step.label === "Metadata") {
      return modelConfig?.entryTerm &&
        modelConfig?.authorName &&
        modelConfig?.studentType
        ? true
        : false;
    }
    return modelConfig?.configs[step.value] ? true : false;
  };

  const isStepDisabled = (stepNumber) => {
    const step = STEPS.find((step) => step.number === stepNumber);
    const previousStep = STEPS.find((step) => step.number === stepNumber - 1);
    // if the step is checkout or the current step, it is not disabled
    if (step.label === "Checkout" || stepNumber === currentStepNumber) {
      return false;
    }

    // if the step is not complete and the previous step is also not complete, it is disabled
    return (
      !isStepComplete(step) && previousStep && !isStepComplete(previousStep)
    );
  };
  return (
    <div className="mb-8 h-full">
      <div className="flex items-center justify-start gap-1">
        {STEPS.map((step, index) => {
          const stepStatus = isStepComplete(step);
          const isDisabled = isStepDisabled(step.number);
          return (
            <React.Fragment key={step.number}>
              <div className="flex items-center">
                <div
                  className={classNames(
                    "flex h-7 w-7 items-center justify-center rounded-full text-xs transition-all",
                    {
                      "bg-blue-03 text-white": stepStatus,
                      "border border-gray-300 bg-white text-gray-400":
                        !stepStatus,
                    }
                  )}
                >
                  {step.number}
                </div>
                <CustomButton
                  customClass={classNames(
                    "!p-0 !font-normal text-md ml-2 whitespace-nowrap transition-all",
                    {
                      "!text-blue-03": currentStepNumber >= step.number,
                      "!text-gray-400": currentStepNumber < step.number,
                      "hover:underline": !isDisabled,
                    }
                  )}
                  variant="text"
                  onClick={() => {
                    navigate(`../fao-builder/${modelConfig?.id}/${step.route}`);
                  }}
                  // steps without a cosmos value are always clickable (metadata/checkout pages)
                  disabled={isDisabled}
                >
                  {step.label}
                </CustomButton>
              </div>
              {index < STEPS.length - 1 && (
                <div className="mx-1 flex items-center">
                  <div
                    className={classNames("h-px w-4", {
                      "bg-blue-03": currentStepNumber > step.number,
                      "bg-gray-200": currentStepNumber <= step.number,
                    })}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressTracker;
